<template>
  <ve-table style="width: 100%;" :scroll-width="scrollWidth" :columns="columns" :table-data="tableData"
    row-key-field-name="keyName" :rowStyleOption="{ stripe: true }" />
</template>
<script>
import { mapGetters } from 'vuex'
import { formatMoney } from '@/util'

export default {
  props: {
    scrollWidth: {
      type: Number,
      require: true
    },
    keyName: {
      type: String,
      require: true
    },
    tableData: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters([
      'achievementRate', 'capacityPerCustomerTarget'
    ]),
    averageData() {
      return this.tableData.find(item => item.vUserName === '汇总') || {}
    },
    columns() {
      const achievementRate = parseInt(this.achievementRate) || 1
      return [
        {
          field: '',
          key: 'expand',
          title: '',
          width: 30,
          align: 'center',
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.isLeaf ? '' : h('div', {
              style: {
                'font-size': '16px',
                position: 'relative',
                top: '-2px'
              },
              on: {
                click: () => {
                  this.$emit('on-expand', row, rowIndex)
                }
              }
            }, row.canExpand ? (row.isExpand ? '-' : '+') : '')
          }
        },
        {
          title: '姓名',
          key: 'vUserName',
          tree: true,
          fixed: 'left',
          align: 'left',
          width: 60,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', {
              style: {
                position: 'relative',
                left: row.isLeaf ? '10px' : 0
              }
            }, row.vUserName || '待修正')
          }
        },
        {
          title: '客产(元)',
          key: 'capacityPerCustomer',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const capacity = Number(row.capacityPerCustomer).toFixed(2)
            let color = ''
            if (Number(capacity) >= this.capacityPerCustomerTarget) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', formatMoney(capacity * achievementRate))
            ])
          }
        },
        {
          title: '回款金额(元)',
          key: 'commissionAmountTotal',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.commissionAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '接待量',
          key: 'hasAgentCnt',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.hasAgentCnt * achievementRate}`)
          }
        },
        {
          title: '有方案/方案量',
          key: 'hasSchemeCnt',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.hasSchemeCnt * achievementRate} / ${row.solutionCnt * achievementRate}`)
          }
        },
        {
          title: '审批中',
          key: 'reviewingCnt',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.reviewingCnt * achievementRate}`)
          }
        },
        {
          title: '通过',
          key: 'approvedCnt',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.approvedCnt * achievementRate}`)
          }
        },
        {
          title: '放款',
          key: 'issuedCnt',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.issuedCnt * achievementRate}`)
          }
        },
        {
          title: '回款',
          key: 'commissionCnt',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.commissionCnt * achievementRate}`)
          }
        },
        {
          title: '批复金额(元)',
          key: 'approvedAmountTotal',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.approvedAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '放款金额(元)',
          key: 'issuedAmountTotal',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.issuedAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '待放金额(元)',
          key: 'waitIssuedAmountTotal',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number((row.approvedAmountTotal - row.issuedAmountTotal) * achievementRate).toFixed(0)))
          }
        },
        {
          title: '方案率',
          key: 'vSchemeRate',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let color = ''
            if (row.vSchemeRate >= this.averageData.vSchemeRate) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${Number(row.vSchemeRate * 100).toFixed(2)}%`)
            ])
          }
        },
        {
          title: '进件率',
          key: 'reviewingRate',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let color = ''
            if (row.reviewingRate >= this.averageData.reviewingRate) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${Number(row.reviewingRate * 100).toFixed(2)}%`)
            ])
          }
        },
        {
          title: '批复率',
          key: 'approvedRate',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let color = ''
            if (row.approvedRate >= this.averageData.approvedRate) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${Number(row.approvedRate * 100).toFixed(2)}%`)
            ])
          }
        },
        {
          title: '件均(元)',
          key: 'issuedAmountAvg',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let color = ''
            if (row.issuedAmountAvg >= this.averageData.issuedAmountAvg) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${formatMoney(Number(row.issuedAmountAvg).toFixed(0))}`)
            ])
          }
        },
        {
          title: '实际点位(%)',
          key: 'commissionPoint',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let color = ''
            if (row.commissionPoint >= this.averageData.commissionPoint) {
              color = '#19be6b'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${Number(row.commissionPoint * 100).toFixed(2)}%`)
            ])
          }
        }
      ]
    }
  }
}
</script>
